import { defineStyleConfig as o } from "@chakra-ui/react";
const e = o({
  baseStyle: {
    textStyle: "bodyBold",
    marginEnd: 3,
    mb: { base: 1, md: 2 },
    transitionProperty: "common",
    transitionDuration: "normal"
  }
});
export {
  e as default
};
